import React from 'react'
import Hero from './Hero'

const Home = () => {
  return (
    <div>
        <Hero />
    </div>
  )
}

export default Home